/*
 * SereniVida CO — Releasit Variant Enforcer
 *
 * Ports ONLY the Mexico "no preselected talla/options" behavior:
 *  1) Quantity Offers: clear preselection + block COD/anticipado until chosen
 *  2) Upsells: same, only when visible select has 2+ real options
 *  3) Stable pack price: while options are still unselected, Releasit prices
 *     the offer as if every pair were already chosen (no partial totals in
 *     the offer card, subtotal, or abandoned checkouts).
 *
 * Does NOT touch ZIP, province COD guard, address altura, shipping, or XHR.
 */
(function () {
  'use strict';

  var PLACEHOLDER_ATTR = 'data-rsi-placeholder';
  var ERROR_CLASS = '_rsi-variant-empty';
  var WARNING_CLASS = '_rsi-variant-missing-warning';
  var SHOW_WARN_CLASS = '_rsi-show-missing-warning';
  var UPSELL_WARN_CLASS = '_rsi-upsell-variant-missing-warning';
  var UPSELL_SHOW_WARN = '_rsi-upsell-show-missing-warning';

  var ALL_VARIANT_SELECTORS = [
    'select[data-offer-num-multi-sel][data-option-num]',
    'select[data-offer-num]'
  ].join(',');
  var ALL_OFFER_VARIANT_SELECTORS = [
    '._rsi-quantity-offers select[data-offer-num-multi-sel][data-option-num]',
    '._rsi-quantity-offers select[data-offer-num]'
  ].join(',');

  function injectStyle() {
    if (document.getElementById('_rsi-variant-enforcer-style')) return;
    var css =
      'select.' + ERROR_CLASS + '{' +
        'outline:2px solid #d33 !important;' +
        'outline-offset:1px !important;' +
        'box-shadow:0 0 0 3px rgba(221,51,51,.15) !important;' +
      '}' +
      '._rsi-quantity-offers .' + WARNING_CLASS + '{' +
        'display:none;margin:12px 0 4px;padding:10px 12px;' +
        'border-radius:8px;background:#fdecea;border:1px solid #f5c6c2;' +
        'color:#8a1f1f;font-size:13px;font-weight:600;text-align:center;' +
        'line-height:1.4;' +
      '}' +
      '._rsi-quantity-offers.' + SHOW_WARN_CLASS + ' .' + WARNING_CLASS + '{' +
        'display:block;' +
      '}' +
      '#_rsi-cod-form-modal-upsell .' + UPSELL_WARN_CLASS + ',' +
      'form._rsi-modal-upsell .' + UPSELL_WARN_CLASS + '{' +
        'display:none;margin:12px 0 4px;padding:10px 12px;' +
        'border-radius:8px;background:#fdecea;border:1px solid #f5c6c2;' +
        'color:#8a1f1f;font-size:13px;font-weight:600;text-align:center;' +
        'line-height:1.4;' +
      '}' +
      '#_rsi-cod-form-modal-upsell.' + UPSELL_SHOW_WARN + ' .' + UPSELL_WARN_CLASS + ',' +
      'form._rsi-modal-upsell.' + UPSELL_SHOW_WARN + ' .' + UPSELL_WARN_CLASS + '{' +
        'display:block;' +
      '}';
    var style = document.createElement('style');
    style.id = '_rsi-variant-enforcer-style';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  // ---------------------------------------------------------------------------
  // Quantity Offers
  // ---------------------------------------------------------------------------

  function placeholderLabelFor(select) {
    var container = select.closest('._rsi-quantity-offers-variant-selector-multi-sel-container');
    var name = container && container.querySelector('._rsi-quantity-offers-multi-sel-optname');
    var label = name ? (name.textContent || '').trim() : '';
    if (!label) label = 'talla';
    return 'Selecciona ' + label.toLowerCase();
  }

  function getAllOfferSelects() {
    return document.querySelectorAll(ALL_OFFER_VARIANT_SELECTORS);
  }

  function clearHiddenVariantId(select) {
    var subItem = select.closest('._rsi-quantity-offers-variant-selector-multi-sel');
    if (subItem) {
      var subItemHidden = subItem.querySelector('input[type="hidden"][data-offer-num]');
      if (subItemHidden) subItemHidden.value = '';
      return;
    }

    var offer = select.closest('._rsi-quantity-offers-offer-container');
    if (!offer) return;

    var hiddenInputs = offer.querySelectorAll(
      'input._rsi-quantity-offers-item-input[name^="item_variant_id"],' +
      'input[type="hidden"][name^="item_variant_id"]'
    );
    for (var i = 0; i < hiddenInputs.length; i++) hiddenInputs[i].value = '';
  }

  function syncHiddenVariantId(select) {
    if (!select || !select.matches('select[data-offer-num]')) return;

    var offer = select.closest('._rsi-quantity-offers-offer-container');
    if (!offer) return;

    var simpleSelects = offer.querySelectorAll('select[data-offer-num]');
    var hiddenInputs = offer.querySelectorAll(
      'input._rsi-quantity-offers-item-input[name^="item_variant_id"],' +
      'input[type="hidden"][name^="item_variant_id"]'
    );
    if (simpleSelects.length === 1 && hiddenInputs.length === 1) {
      hiddenInputs[0].value = select.value || '';
    }
  }

  function clearPreselection(select) {
    if (!select) return;
    if (select.getAttribute(PLACEHOLDER_ATTR) === '1') {
      // Already processed. Releasit rebuilds the 2nd option list (talla) when
      // the 1st option (color) changes, wiping our placeholder and
      // preselecting the first talla. Re-apply only in that case.
      if (select.querySelector('option[' + PLACEHOLDER_ATTR + ']')) return;
      select.removeAttribute(PLACEHOLDER_ATTR);
    }

    var opts = select.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) opts[i].removeAttribute('selected');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.setAttribute(PLACEHOLDER_ATTR, '1');
    placeholder.textContent = placeholderLabelFor(select);
    select.insertBefore(placeholder, select.firstChild);
    select.value = '';
    select.setAttribute(PLACEHOLDER_ATTR, '1');

    clearHiddenVariantId(select);

    if (!select.__codOfferBound) {
      select.__codOfferBound = true;
      select.addEventListener('change', function () {
        syncHiddenVariantId(select);
        if (select.value) select.classList.remove(ERROR_CLASS);
        revalidateOffers();
      });
    }
  }

  function setupSelects() {
    var selects = getAllOfferSelects();
    for (var i = 0; i < selects.length; i++) clearPreselection(selects[i]);
  }

  function getSelectedOfferContainer() {
    return document.querySelector(
      '._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected'
    ) || document.querySelector('._rsi-quantity-offers-offer-container');
  }

  function getEmptySelectsInSelectedOffer() {
    var offer = getSelectedOfferContainer();
    if (!offer) return [];
    var selects = offer.querySelectorAll(ALL_VARIANT_SELECTORS);
    var empties = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) empties.push(selects[i]);
    }
    return empties;
  }

  function ensureWarning() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return null;
    var warn = wrap.querySelector('.' + WARNING_CLASS);
    if (!warn) {
      warn = document.createElement('div');
      warn.className = WARNING_CLASS;
      wrap.appendChild(warn);
    }
    var warningText = warningTextForSelectedOffer();
    if (warn.textContent !== warningText) warn.textContent = warningText;
    return warn;
  }

  function warningTextForSelectedOffer() {
    var offer = getSelectedOfferContainer();
    if (!offer) {
      return 'Por favor, selecciona las opciones de todos los pares antes de continuar.';
    }

    var selects = offer.querySelectorAll(ALL_VARIANT_SELECTORS);
    var hasTalla = false;
    var hasColor = false;

    for (var i = 0; i < selects.length; i++) {
      var label = placeholderLabelFor(selects[i]).replace(/^Selecciona\s+/i, '');
      if (label === 'talla') hasTalla = true;
      if (label === 'color') hasColor = true;
    }

    if (hasTalla && hasColor) {
      return 'Por favor, selecciona talla y color de todos los pares antes de continuar.';
    }
    if (hasTalla) {
      return 'Por favor, selecciona la talla de todos los pares antes de continuar.';
    }
    return 'Por favor, selecciona las opciones de todos los pares antes de continuar.';
  }

  function revalidateOffers() {
    var wrap = document.querySelector('._rsi-quantity-offers');
    if (!wrap) return;
    ensureWarning();
    if (getEmptySelectsInSelectedOffer().length === 0) {
      wrap.classList.remove(SHOW_WARN_CLASS);
      var selects = getAllOfferSelects();
      for (var i = 0; i < selects.length; i++) selects[i].classList.remove(ERROR_CLASS);
    }
  }

  function variantsComplete() {
    return getEmptySelectsInSelectedOffer().length === 0;
  }

  function flagMissing() {
    var empties = getEmptySelectsInSelectedOffer();
    for (var i = 0; i < empties.length; i++) empties[i].classList.add(ERROR_CLASS);

    var wrap = document.querySelector('._rsi-quantity-offers');
    if (wrap && empties.length) {
      wrap.classList.add(SHOW_WARN_CLASS);
      if (empties[0].scrollIntoView) {
        try { empties[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { empties[0].scrollIntoView(); }
      }
    }
    return empties.length === 0;
  }

  function installSubmitGuards() {
    if (installSubmitGuards._done) return;

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;

      var codBtn = target.closest('._rsi-build-block-submit-button');
      var advBtn = target.closest('a._rsi-buy-now-custom-additionals-button');
      if (!codBtn && !advBtn) return;
      if (!document.querySelector('._rsi-quantity-offers')) return;

      if (!variantsComplete()) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        flagMissing();
      }
    }, true);

    installSubmitGuards._done = true;
  }

  // ---------------------------------------------------------------------------
  // Upsells (fixed MX logic: never wipe customer choice; skip products w/o sizes)
  // ---------------------------------------------------------------------------

  function getUpsellRoots() {
    return document.querySelectorAll('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
  }

  function isVisibleEl(el) {
    if (!el) return false;
    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return false;
    var p = el.parentElement;
    while (p) {
      var ps = window.getComputedStyle ? window.getComputedStyle(p) : null;
      if (ps && ps.display === 'none') return false;
      p = p.parentElement;
    }
    return true;
  }

  function countRealOptions(select) {
    var opts = select.querySelectorAll('option');
    var n = 0;
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].value;
      if (v == null || String(v).trim() === '') continue;
      if (opts[i].getAttribute(PLACEHOLDER_ATTR) === '1') continue;
      n++;
    }
    return n;
  }

  function getRequiredUpsellSelects(root) {
    if (!root || !root.querySelectorAll) return [];
    var all = root.querySelectorAll(
      '._rsi-modal-upsell-variant-selector select, ._rsi-modal-upsell-variants select[data-option-name], select[data-option-name]'
    );
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      if (!isVisibleEl(s)) continue;
      if (countRealOptions(s) < 2) continue;
      out.push(s);
    }
    return out;
  }

  function placeholderLabelForUpsell(select) {
    var item = select.closest('._rsi-modal-upsell-variant-selector, ._rsi-modal-fields-item');
    var labelEl = item && item.querySelector('label');
    var label = labelEl ? (labelEl.textContent || '').trim() : '';
    if (!label) label = select.getAttribute('data-option-name') || 'opción';
    return 'Selecciona ' + label.toLowerCase();
  }

  function clearUpsellPreselection(select) {
    if (!select) return;
    // Already processed — NEVER wipe the customer's choice
    if (select.getAttribute(PLACEHOLDER_ATTR) === '1') return;
    if (countRealOptions(select) < 2) return;

    var opts = select.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) opts[i].removeAttribute('selected');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.setAttribute(PLACEHOLDER_ATTR, '1');
    placeholder.textContent = placeholderLabelForUpsell(select);
    select.insertBefore(placeholder, select.firstChild);
    select.value = '';
    select.setAttribute(PLACEHOLDER_ATTR, '1');

    if (!select.__codUpsellBound) {
      select.__codUpsellBound = true;
      select.addEventListener('change', function () {
        var root = select.closest('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
        if (select.value) select.classList.remove(ERROR_CLASS);
        if (root && upsellVariantsComplete(root)) hideUpsellWarning(root);
      });
    }
  }

  function ensureUpsellWarning(root) {
    if (!root) return null;
    var warn = root.querySelector('.' + UPSELL_WARN_CLASS);
    if (!warn) {
      warn = document.createElement('div');
      warn.className = UPSELL_WARN_CLASS;
      warn.textContent = 'Por favor, selecciona la talla antes de aceptar la oferta.';
      var variants = root.querySelector('._rsi-modal-upsell-variants');
      if (variants && variants.parentNode) {
        variants.parentNode.insertBefore(warn, variants.nextSibling);
      } else {
        var btn = root.querySelector('#_rsi-modal-submit-button-upsell, ._rsi-modal-submit-button-upsell');
        if (btn && btn.parentNode) btn.parentNode.insertBefore(warn, btn);
        else root.appendChild(warn);
      }
    }
    return warn;
  }

  function hideUpsellWarning(root) {
    if (!root) return;
    root.classList.remove(UPSELL_SHOW_WARN);
    var warn = root.querySelector('.' + UPSELL_WARN_CLASS);
    if (warn) warn.style.display = 'none';
    var selects = getRequiredUpsellSelects(root);
    for (var i = 0; i < selects.length; i++) selects[i].classList.remove(ERROR_CLASS);
  }

  function upsellVariantsComplete(root) {
    var selects = getRequiredUpsellSelects(root);
    if (!selects.length) return true;
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) return false;
    }
    return true;
  }

  function flagUpsellMissing(root) {
    var selects = getRequiredUpsellSelects(root);
    var empties = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) {
        selects[i].classList.add(ERROR_CLASS);
        empties.push(selects[i]);
      }
    }
    if (empties.length) {
      var warn = ensureUpsellWarning(root);
      if (warn) warn.style.display = 'block';
      root.classList.add(UPSELL_SHOW_WARN);
      if (empties[0].scrollIntoView) {
        try { empties[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { empties[0].scrollIntoView(); }
      }
    }
    return empties.length === 0;
  }

  function setupUpsellSelects() {
    var roots = getUpsellRoots();
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var required = getRequiredUpsellSelects(root);
      if (!required.length) {
        hideUpsellWarning(root);
        continue;
      }
      for (var i = 0; i < required.length; i++) clearUpsellPreselection(required[i]);
      if (upsellVariantsComplete(root)) hideUpsellWarning(root);
    }
  }

  function installUpsellSubmitGuards() {
    if (installUpsellSubmitGuards._done) return;

    document.addEventListener('click', function (ev) {
      var target = ev.target;
      if (!target || !target.closest) return;

      if (target.closest('#_rsi-modal-submit-button-upsell-no-thanks, ._rsi-modal-submit-button-upsell-no-thanks')) {
        return;
      }

      var accept = target.closest(
        '#_rsi-modal-submit-button-upsell, button._rsi-modal-submit-button-upsell'
      );
      if (!accept) return;
      if (accept.classList && accept.classList.contains('_rsi-modal-submit-button-upsell-no-thanks')) return;

      var root = accept.closest('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell')
        || document.querySelector('#_rsi-cod-form-modal-upsell, form._rsi-modal-upsell');
      if (!root) return;

      var required = getRequiredUpsellSelects(root);
      if (!required.length) return;

      if (!upsellVariantsComplete(root)) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        flagUpsellMissing(root);
      }
    }, true);

    installUpsellSubmitGuards._done = true;
  }

  // ---------------------------------------------------------------------------
  // Stable pack price
  //
  // Releasit prices a quantity offer by reading every pair's variant id from
  // the DOM (select[data-offer-num] / input[data-offer-num]) and summing the
  // matching variant prices. Pairs we left unselected have an empty id, so
  // they priced as $0 and the customer saw the pack grow one pair at a time
  // ($10.002 -> $140.001 -> $399.999). That same partial total was what
  // Releasit sent to abandoned checkouts.
  //
  // We wrap _rsi.form.quantityOffers.calculateSelectedOfferData so that any
  // pair still unselected is priced as the product's default variant. The
  // visible selects keep their placeholder and the submit guard still blocks
  // until every pair is really chosen; only the money math changes.
  // ---------------------------------------------------------------------------

  function getQuantityOffersApi() {
    try {
      var rsi = window._rsi;
      if (!rsi || !rsi.form || !rsi.form.quantityOffers) return null;
      var qo = rsi.form.quantityOffers;
      if (typeof qo.calculateSelectedOfferData !== 'function') return null;
      return qo;
    } catch (e) {
      return null;
    }
  }

  function isEmptyVariantKey(key) {
    if (key == null) return true;
    var k = String(key).trim();
    return k === '' || k === 'undefined' || k === 'null' || k === 'false' || k === '0';
  }

  function pickFallbackVariant(qo, chosenVariants) {
    var cache = qo.productCache;
    if (!cache || !cache.variants || !cache.variants.length) return null;
    var variants = cache.variants;
    var i;

    // Prefer a variant the customer already picked in this offer (same product,
    // same price) so abandoned checkouts look coherent.
    var chosenIds = Object.keys(chosenVariants || {});
    for (i = 0; i < chosenIds.length; i++) {
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === String(chosenIds[i])) return variants[j];
      }
    }
    for (i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0];
  }

  function stabilizeOfferData(qo, result, offerEl, offer) {
    if (!result || !result.variants) return result;

    var variants = result.variants;
    var missing = 0;
    var chosen = 0;
    var keys = Object.keys(variants);

    for (var i = 0; i < keys.length; i++) {
      var qty = parseInt(variants[keys[i]], 10) || 0;
      if (isEmptyVariantKey(keys[i])) {
        missing += qty;
        delete variants[keys[i]];
      } else {
        chosen += qty;
      }
    }

    // Also cover pairs whose hidden input Releasit never created.
    var targetQty = offer && offer.qty ? parseInt(offer.qty, 10) : 0;
    if (!targetQty && qo.selectedOfferIn && qo.selectedOfferIn.qty) {
      var isSelected = !offerEl || offerEl.classList.contains('_rsi-quantity-offers-selected');
      if (isSelected) targetQty = parseInt(qo.selectedOfferIn.qty, 10) || 0;
    }
    if (targetQty && chosen + missing < targetQty) missing = targetQty - chosen;

    if (missing <= 0) return result;

    var fallback = pickFallbackVariant(qo, variants);
    if (!fallback) return result;

    var id = String(fallback.id);
    variants[id] = (variants[id] || 0) + missing;
    result.orderTotal = (result.orderTotal || 0) + (Number(fallback.price) || 0) * missing;
    result.orderWeight = (result.orderWeight || 0) + (Number(fallback.weight) || 0) * missing;
    return result;
  }

  function patchReleasitPricing() {
    if (patchReleasitPricing._done) return true;
    var qo = getQuantityOffersApi();
    if (!qo) return false;
    if (qo.calculateSelectedOfferData.__codStablePrice) {
      patchReleasitPricing._done = true;
      return true;
    }

    var original = qo.calculateSelectedOfferData;
    var wrapped = function (offerEl, offer) {
      var result = original.apply(this, arguments);
      try {
        return stabilizeOfferData(qo, result, offerEl, offer);
      } catch (e) {
        return result;
      }
    };
    wrapped.__codStablePrice = true;
    qo.calculateSelectedOfferData = wrapped;
    patchReleasitPricing._done = true;
    return true;
  }

  function startPricingPatchPoller() {
    if (patchReleasitPricing()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (patchReleasitPricing() || ++tries > 600) clearInterval(iv);
    }, 500);
  }

  // ---------------------------------------------------------------------------
  // Bootstrap
  // ---------------------------------------------------------------------------

  function tick() {
    patchReleasitPricing();
    setupSelects();
    ensureWarning();
    setupUpsellSelects();
  }

  function start() {
    injectStyle();
    installSubmitGuards();
    installUpsellSubmitGuards();
    startPricingPatchPoller();
    tick();

    new MutationObserver(tick).observe(document.body, {
      childList: true,
      subtree: true
    });

    var c = 0;
    var iv = setInterval(function () {
      tick();
      if (++c > 120) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
